export default __webpack_public_path__ + "static/media/cake.13b31723.jpg";